import { faEdit, faPlus, faRepeat } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import swal from '@sweetalert/with-react';
import moment from 'moment';
import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import ReactTable from 'react-table';
import settings from '../../../../settings';
import Button from '../../../components/Button';
import HeaderbarButton from '../../../components/HeaderbarButton';
import Switch from '../../../components/Inputs/Switch';
import Loader from '../../../components/Loader';
import Searchbar from '../../../components/Searchbar';
import SearchDropdown from '../../../components/SearchDropdown';
import history from '../../../history';
import UserContext from '../../../hooks/UserContext';
import api from '../../../logic/api';
import getConstants from '../../../logic/constants';
import DataContainer from '../../../logic/dataContainer';
import Highlight from '../../../components/Highlight';

class ClientsOverview extends Component {
  constructor(props) {
    super(props);

    const params = new URLSearchParams(props.location.search);

    this.state = {
      loading: true,
      loadingAppointments: false,
      data: [],
      filteredData: [],
      appointments: [],
      query: params.get('query')?.toLowerCase() || '',
      caseStatusGuid: params.get('status')?.toLowerCase() || '',
      placeOfStorageQueryGuid: params.get('place')?.toLowerCase() || '',
      carePsychGuid: params.get('carepsych')?.toLowerCase() || '',
      CarePsych: [],
      CaseStatus: [],
      PlaceOfStorage: [],
      includeClosedCases: false,
      searchInput: '',
      filtered: [],
    };
  }

  async componentDidMount() {
    await this.initConstants();
    this.loadClients();
  }

  static contextType = UserContext;

  async initConstants() {
    this.setState({
      CarePsych: await getConstants('CarePsych'),
      CaseStatus: await getConstants('CaseStatus'),
      PlaceOfStorage: await getConstants('PlaceOfStorage'),
    });
  }

  loadClients = (includeClosedCases = false) => {
    this.setState({
      loading: true,
      data: [],
      filteredData: [],
    });

    const dataColumns = {
      Guid: '',
      LastName: '',
      FirstName: '',
      AddrCity: '',
      UpdateDate: '',
      UpdateUserName: '',
      IsDone: '',
      Question: '',
      CreateDate: '',
      CaseStatus: '',
      Answer: '',
      PlaceOfStorage: '',
      Chiffre: '',
    };

    api(
      'get',
      settings.clientmanagement.client.getFilteredClientList,
      {
        columns: JSON.stringify(dataColumns),
        includeClosedCases,
      },
      false,
    )
      .then(async (res) => {
        const filteredClientData = new DataContainer(res).getMany(
          'FilteredClient',
        );
        if (filteredClientData.length > 0) {
          this.setState({
            data: filteredClientData,
            filteredData: filteredClientData,
            loading: false,
          });
          await this.loadAppointments();
          this.applyFilters();
        }
      })
      .catch(() => {
        this.setState({
          data: [],
          filteredData: [],
          loading: false,
        });
      });
  };

  async loadAppointments() {
    this.setState({
      loadingAppointments: true,
    });
    const dataColumns = {
      Typ: 'Appointment',
      GetClosedAppointments: true,
    };
    await api('get', settings.clientmanagement.dataContainer.getList, {
      parameter: JSON.stringify(dataColumns),
    })
      .then((res) => {
        const appointmentsDC = new DataContainer(res);
        this.setState({
          appointments: appointmentsDC.getMany('Entry'),
          loadingAppointments: false,
        });

        const updatedClientData = this.state.data.map((client) => {
          // CARE-768: den NEUESTEN Termin des Klienten wählen (nicht den frühesten),
          // damit "Beraten durch" bei Therapeutenwechsel oder weiterer Terminvergabe
          // aktualisiert wird. Guard gegen Einträge ohne ClientGuid.
          const appointment = appointmentsDC
            .getMany('Entry')
            .filter(
              (a) =>
                a.ClientGuid &&
                a.ClientGuid.toLowerCase() === client.Guid.toLowerCase(),
            )
            .sort((a, b) =>
              a.DateOfAppointment > b.DateOfAppointment ? -1 : 1,
            )[0];

          if (appointment === undefined || appointment === null) {
            return { ...client, CarePsych: '' };
          }

          const carePsychName =
            this.state.CarePsych.find(
              (elem) => elem.value === appointment.CarePsych,
            )?.label || '';
          return { ...client, CarePsych: carePsychName };
        });

        this.setState({
          data: updatedClientData,
          filteredData: updatedClientData,
        });
      })
      .catch(() => {
        this.setState({
          loadingAppointments: false,
        });
      });
  }

  setPath = (query, status, place, carepsych) => {
    const baseURI = this.props.match.path.endsWith('search')
      ? this.props.match.path.substring(0, this.props.match.path.length - 7)
      : this.props.match.path.substring(0, this.props.match.path.length - 1);

    // Get the current search parameters from the URL
    const currentSearchParams = new URLSearchParams();
    if (query.length > 0) currentSearchParams.set('query', query);
    if (status.length > 0) currentSearchParams.set('status', status);
    if (place.length > 0) currentSearchParams.set('place', place);
    if (carepsych && carepsych.length > 0)
      currentSearchParams.set('carepsych', carepsych);

    const newPath = `${baseURI}/search?${currentSearchParams.toString()}`;

    history.replace(newPath);
  };

  _search = (value) => {
    const query = value.toLowerCase();

    this.setState({ query: query }, () => {
      this.setPath(
        query,
        this.state.caseStatusGuid,
        this.state.placeOfStorageQueryGuid,
      );
      this.applyFilters();
    });
  };

  handleFilterChange = (v) => {
    const value = v.toLowerCase() || '';
    // If there's input, apply filters to all relevant columns
    if (value) {
      this.setState({
        searchInput: value,
        filtered: [
          { id: 'LastName', value },
          { id: 'FirstName', value },
          { id: 'AddrCity', value },
          { id: 'UpdateUserName', value },
          { id: 'LastContact', value },
          { id: 'CaseStatusText', value },
          { id: 'PlaceOfStorage', value },
          { id: 'CarePsych', value },
          { id: 'Chiffre', value },
        ],
      });
    } else {
      // If input is empty, clear filters
      this.setState({ searchInput: '', filtered: [] });
    }
  };

  getCarePsychName = (guid) => {
    const carePsych = this.state.CarePsych.find((elem) => elem.value === guid);
    return carePsych ? carePsych.label : '';
  };

  // Filter rows
  filter = (key, value) => {
    const newValue = !!value ? value.toLowerCase() : '';

    this.setState({ [key]: newValue }, () => {
      if (key === 'caseStatusGuid') {
        this.setPath(
          this.state.query,
          newValue,
          this.state.placeOfStorageQueryGuid,
        );
      }
      if (key === 'placeOfStorageQueryGuid') {
        this.setPath(this.state.query, this.state.caseStatusGuid, newValue);
      }
      if (key === 'carePsychGuid') {
        this.setPath(
          this.state.query,
          this.state.caseStatusGuid,
          this.state.placeOfStorageQueryGuid,
          newValue,
        );
      }

      // Apply filters after setting the state
      this.applyFilters();
    });
  };

  applyFilters = () => {
    const {
      query,
      caseStatusGuid,
      placeOfStorageQueryGuid,
      carePsychGuid,
      data,
    } = this.state;

    // Early return if no filters applied
    if (
      !query &&
      !caseStatusGuid &&
      !placeOfStorageQueryGuid &&
      !carePsychGuid
    ) {
      this.setState({ filteredData: data });
      return;
    }
    const filteredData = data.reduce((acc, rowData) => {
      // --------- Searchable Fields ---------
      const searchableFields = [
        rowData.LastName,
        rowData.FirstName,
        rowData.AddrCity,
        rowData.UpdateUserName,
        rowData.LastContact,
        rowData.CreateDate,
        rowData.CaseStatusText,
        rowData.PlaceOfStorageText,
        rowData.CarePsych,
      ].map((field) => field?.toLowerCase());

      const matchesQuery = query
        ? searchableFields.some(
            (field) => field?.includes(query.toLowerCase()) ?? false,
          )
        : true;

      // --------- Filter Conditions ---------
      const carePsychName = this.getCarePsychName(carePsychGuid);
      const matchesAllFilters =
        (!caseStatusGuid || rowData.CaseStatus === caseStatusGuid) &&
        (!placeOfStorageQueryGuid ||
          rowData.PlaceOfStorage === placeOfStorageQueryGuid) &&
        (query ? matchesQuery : true) &&
        (!carePsychGuid || rowData.CarePsych === carePsychName);

      if (matchesAllFilters) {
        acc.push(rowData);
      }
      return acc;
    }, []);

    this.setState({ filteredData });
  };

  //! Don't remove this function now, maybe we need it later
  _openClient = (client) => {
    swal({
      title: 'Sicherheitsabfrage',
      text: `Bitte wählen...`,
      buttons: {
        back: 'abbrechen',
        without: {
          text: 'ohne Sicherheitsfrage öffnen',
        },
        correct: 'Telefonische Beratung, Antwort prüfen',
      },
    }).then((value) => {
      switch (value) {
        case 'without':
          return this.props.history.push(
            `/clientmanagement/detail/${client.Guid}`,
          );
        case 'correct':
          swal({
            title: `${client.Question}`,
            text: `Antwort: ${client.Answer}`,
            buttons: {
              back: 'Antwort falsch',
              correct: 'Antwort richtig',
            },
          }).then((value) => {
            switch (value) {
              case 'correct':
                swal(
                  'Telefonische Beratung. Zugriff wird in Historie gespeichert.',
                  { icon: 'success' },
                );
                return this.props.history.push(
                  `/clientmanagement/detail/${client.Guid}/log`,
                );
              default:
                break;
            }
          });
          break;
        default:
          break;
      }
    });
  };

  _deleteClient = (client) => {
    swal({
      title: 'Löschen?',
      buttons: {
        cancle: 'abbrechen',
        delete: 'löschen',
      },
    }).then((value) => {
      if (value !== 'delete') {
        return;
      }
      api('POST', settings.clientmanagement.dataContainer.remove, {
        guid: client.Guid,
        action: 'Klient/in gelöscht',
        clientGuid: client.Guid,
      })
        .then(() => {
          swal({
            title: 'Gelöscht!',
            text: 'Erfolgreich gelöscht.',
            icon: 'success',
          });
          this.props.history.goBack();
        })
        .catch(() => {
          swal({
            title: 'Löschen nicht möglich!',
            text: 'Es ist ein Fehler beim löschen aufgetreten',
            icon: 'error',
          });
        });
    });
  };

  render() {
    if (this.state.loading) {
      return <Loader text="Klienten werden geladen..." />;
    }

    const { filteredData, filtered, searchInput } = this.state;

    // Anzahl der tatsächlich angezeigten Zeilen: filteredData (Dropdown-Filter)
    // zusätzlich um die Volltextsuche reduziert (react-table filtert diese intern,
    // daher hier mit derselben Logik wie defaultFilterMethod nachgerechnet).
    const displayedCount = searchInput
      ? filteredData.filter((row) =>
          Object.keys(row).some((key) => {
            const cellValue = row[key];
            return (
              cellValue !== undefined &&
              cellValue !== null &&
              String(cellValue).toLowerCase().includes(searchInput)
            );
          }),
        ).length
      : filteredData.length;

    return (
      <>
        <div className="Headerbar sticky">
          <div className="Headerbar-breadcrumbs">
            <b>Klientenverwaltung</b>
          </div>
          <div className="Headerbar-buttons">
            <HeaderbarButton icon={faRepeat} onClick={this.loadClients}>
              Liste aktualisieren
            </HeaderbarButton>
          </div>
        </div>
        <div className="Page-Content">
          <div className="Buttonbar">
            <Button
              icon={faPlus}
              onClick={() => {
                this.props.history.push(`/clientmanagement/new`);
              }}
              replace
            >
              Neuer Klient/in
            </Button>
          </div>
          <div className="Client-Toolbar">
            <Searchbar
              placeholder="Volltextsuche"
              defaultValue={this.state.searchInput}
              onChange={this.handleFilterChange}
            />
            <div className="Client-Toolbar-Filter-Area">
              <SearchDropdown
                label="Fallstatus:"
                options={this.state.CaseStatus}
                defaultValue={this.state.caseStatusGuid}
                onChange={(value) => {
                  this.filter('caseStatusGuid', value);
                }}
              />
              <SearchDropdown
                label="Beraten durch:"
                options={this.state.CarePsych}
                defaultValue={this.state.carePsychGuid}
                onChange={(value) => {
                  this.filter('carePsychGuid', value);
                }}
              />
              <SearchDropdown
                label="Aufbewahrungsort des Stammdatenblatts.:"
                options={this.state.PlaceOfStorage}
                defaultValue={this.state.placeOfStorageQueryGuid}
                onChange={(value) => {
                  this.filter('placeOfStorageQueryGuid', value);
                }}
              />
              <Switch
                label="Abgeschlossene Fälle auch anzeigen"
                onChange={(value) => {
                  this.loadClients(value);
                  this.setState({ includeClosedCases: value });
                }}
                labelActive="Ja"
                labelInactive="Nein"
                defaultChecked={this.state.includeClosedCases}
              />
            </div>
            <span className="Searchbar-Results-Amount">
              {displayedCount} Einträge
            </span>
          </div>
          <ReactTable
            resizable={true}
            getTrProps={(_, val) => ({
              onClick: (ev) => {
                if (ev.target.className === 'delete') {
                  return this._deleteClient(val?.original);
                }

                return this._openClient(val?.original);
              },
            })}
            defaultFilterMethod={(filter, row) => {
              const searchValue = filter.value.toLowerCase();

              return Object.keys(row).some((key) => {
                const cellValue = row[key];

                return (
                  cellValue !== undefined &&
                  cellValue !== null &&
                  String(cellValue).toLowerCase().includes(searchValue)
                );
              });
            }}
            filtered={this.state.filtered}
            defaultSorted={[
              {
                id: 'LastName',
                desc: false,
              },
            ]}
            pageSize={filteredData.length}
            data={this.state.filteredData}
            noDataText="Es wurden keine Klienten gefunden."
            columns={[
              {
                accessor: 'Chiffre',
                Header: 'Chiffre',
                Cell: ({ original }) => (
                  <Highlight
                    text={original.Chiffre}
                    highlight={this.state.searchInput}
                  />
                ),
              },
              {
                accessor: 'LastName',
                Header: 'Name',
                Cell: ({ original }) => (
                  <Highlight
                    text={original.LastName}
                    highlight={this.state.searchInput}
                  />
                ),
              },
              {
                accessor: 'FirstName',
                Header: 'Vorname',
                Cell: ({ original }) => (
                  <Highlight
                    text={original.FirstName}
                    highlight={this.state.searchInput}
                  />
                ),
              },
              {
                accessor: 'AddrCity',
                Header: 'Wohnort',
                Cell: ({ original }) => (
                  <Highlight
                    text={original.AddrCity}
                    highlight={this.state.searchInput}
                  />
                ),
              },
              {
                accessor: 'CarePsych',
                Header: 'Beraten durch',
                Cell: ({ original }) => (
                  <Highlight
                    text={original.CarePsych}
                    highlight={this.state.searchInput}
                  />
                ),
              },
              {
                accessor: 'CreateDate',
                Header: 'Angelegt am',
                sortMethod: (a, b) => {
                  return moment(a, 'DD.MM.YYYY hh:mm:ss').isBefore(
                    moment(b, 'DD.MM.YYYY hh:mm:ss'),
                  )
                    ? -1
                    : 1;
                },
                Cell: ({ original }) => {
                  return (
                    <>
                      {moment(
                        original.CreateDate,
                        'DD.MM.YYYY hh:mm:ss',
                      ).format('DD.MM.YYYY')}
                    </>
                  );
                },
              },
              {
                accessor: 'UpdateDate',
                Header: 'Letzte Speicherung',
                sortMethod: (a, b) =>
                  moment(a, 'DD.MM.YYYY hh:mm:ss').isBefore(
                    moment(b, 'DD.MM.YYYY hh:mm:ss'),
                  )
                    ? -1
                    : 1,
                Cell: ({ original }) => (
                  <>
                    {moment(original.UpdateDate, 'DD.MM.YYYY hh:mm:ss').format(
                      'DD.MM.YYYY',
                    )}
                  </>
                ),
              },
              {
                accessor: 'CaseStatus',
                Header: 'Fallstatus',
                Cell: ({ original }) => (
                  <Highlight
                    text={original.CaseStatusText || ''}
                    highlight={this.state.searchInput}
                  />
                ),
              },
              {
                accessor: 'PlaceOfStorage',
                Header: 'Stammdatenblatt',
                Cell: ({ original }) => (
                  <Highlight
                    text={original.PlaceOfStorageText}
                    highlight={this.state.searchInput}
                  />
                ),
              },
              {
                accessor: 'Link',
                Header: 'Zur Detailansicht',
                Cell: () => (
                  <>
                    <u>Hier klicken</u>&nbsp;
                    <FontAwesomeIcon icon={faEdit} />
                  </>
                ),
              },
            ]}
          />
        </div>
      </>
    );
  }

  getCarePsychByAppointment(Guid) {
    let carePsychName = '';
    const appointment = this.state.appointments.find(
      (a) => a.ClientGuid === Guid,
    );
    if (appointment) {
      carePsychName = this.state.CarePsych.find(
        (elem) => elem.value === appointment.CarePsych,
      )?.label;
    }
    return carePsychName;
  }
}

export default withRouter(ClientsOverview);
